import * as React from 'react';
import { CardHeader } from '../common/authenticationCardComponents/CardHeader';
import { SocialButton } from '../common/authenticationCardComponents/SocialButton';
import { validateEmail } from '../../services/validators/EmailValidator';
import { useEffect, useState } from 'react';
import { PageRoutes } from '../root/Routes';
import { EnvelopeIcon } from '../common/Icons';
import { History } from 'history';
import {
    EMAIL_INVALID_DEFAULT_MESSAGE,
    GOOGLE_IDENTITY_PROVIDER,
    I_ALREADY_HAVE_AN_ACCOUNT_MESSAGE, SIGN_IN_MESSAGE
} from '../../utils/constants';
import { AuthenticationFooter } from '../common/authenticationCardComponents/AuthenticationFooter';
import { LucidLinkLogo } from '../common/Icons';
import { LUCIDLINK_WEBSITE } from '../../utils/constants';
import { AuthenticationFooterSecondary } from '../common/authenticationCardComponents/AuthenticationFooterSecondary';

interface EmailStepProps {
    history: History;
    handleEmailState: (email: string) => void;
}

export default function EmailStep(props: EmailStepProps): JSX.Element {
    const [email, setEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [isInputPristine, setIsInputPristine] = useState(true);

    useEffect(() => {
        const prevEmail = props.history.location.state?.email;
        if (prevEmail) {
            const isPrevEmailValid = validateEmail(prevEmail);
            setIsEmailValid(isPrevEmailValid);
            setIsInputPristine(false);
            setEmail(prevEmail);
            props.history.location.state.email = '';
        }
    });

    return (
        <div className="auth_wrapper">
            <header>
                <a href={LUCIDLINK_WEBSITE}>
                    <LucidLinkLogo width={'130px'} height={'50px'}/>
                </a>
            </header>
            <div className="auth_block">
                <div>
                    <CardHeader message={headerMessage()}/>
                    <div className="auth_form">
                        <SocialButton identityProvider={GOOGLE_IDENTITY_PROVIDER} text={'Sign up with Google'}/>
                        <p>
                            or sign up with
                        </p>
                        <div className={(isInputPristine && 'float-label-control') || (isEmailValid ? 'float-label-control' : 'float-label-control has-danger')}>
                            <input
                                type="email"
                                placeholder="E-mail address"
                                className="form-control"
                                autoFocus={true}
                                name="email"
                                id="email"
                                value={email}
                                onChange={handleEmailChange}
                                onKeyDown={(e) => {handleEnter(e, props); }}
                            />
                            <label>E-mail address</label>
                            <span className="icon">
                                <EnvelopeIcon width={'17px'} height={'18px'} fill={(isInputPristine && 'black') || (isEmailValid ? '#9DC53B' : '#F40000')}/>
                            </span>
                            <div className="row">
                                {(!isEmailValid && !isInputPristine) &&
                                    <span className="minitext pt-2">{EMAIL_INVALID_DEFAULT_MESSAGE}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div>
                        <p>No credit card required.</p>
                        <button
                            className="btn"
                            disabled={!isEmailValid}
                            onClick={() => onRegistrationButtonClick(props)}
                        >
                            <span className="label__custom">Try 14 Days Free</span>
                        </button>
                    </div>
                    <AuthenticationFooter message={{text: I_ALREADY_HAVE_AN_ACCOUNT_MESSAGE, label: SIGN_IN_MESSAGE}}/>
                </div>
            </div>
            <AuthenticationFooterSecondary linkHref="https://app.lucidlink.com/register" linkLabel="Try the new LucidLink" />
        </div>
    );

    function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const currentEmail = e.target.value.trim();
        const isValidEmail = validateEmail(currentEmail);
        setIsInputPristine(false);
        setEmail(currentEmail);
        setIsEmailValid(isValidEmail);
    }

    function onRegistrationButtonClick(emailStepProps: EmailStepProps): void {
        emailStepProps.handleEmailState(email);
        emailStepProps.history.push(PageRoutes.PasswordStep);
    }

    function handleEnter(event: any, emailStepProps: EmailStepProps) {
        const ENTER_KEYCODE = 13;
        if (!isInputPristine && isEmailValid) {
            if (event.keyCode === ENTER_KEYCODE) {
                onRegistrationButtonClick(emailStepProps);
            }
        }
    }

    function headerMessage(): JSX.Element {
        return (
            <>
                Get Projects Done Faster. <br /> Sign Up Today.
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/authentication/EmailStep.tsx